"use strict";
import $ from "jquery";
import ActivityStreamHelper from "../helpers/activity_stream";
import Auth from "../util/auth";
import AuditFlagReview from "./factoring/audit_flag_review";
import Account from "../api/account";
import Api from "../api/api";
import DocumentBatchViews from "../api/document_batch_views";
import Blocker from "./blocker";
import CarrierChooser from "./indexer/carrier_chooser";
import CarrierSetter from "./carrier_setter";
import CarrierService from "../services/carrier_service";
import ClientNotesSidebar, {
  ClientNotesSidebarTrigger
} from "./indexer/client_notes_sidebar";
import classNames from "classnames";
import documentEditor from "./document_editor";
import DocumentBrowser from "./react_document_browser";
import DocumentGroupEditor from "./document_group_editor";
import DocumentTypesSetter from "./indexer/document_types_setter";
import DuplicateBrokerInvoiceConfirmation from "./duplicate_broker_invoice_confirmation";
import EmailHelper from "../helpers/email_message";
import EmailMergerView from "./email_merger_view";
import FactorInvoice from "./indexer/factor_invoice";
import DebtorSetter from "./indexer/debtor_setter";
import ReviewGroups from "./indexer/review_groups";
import IgnoreEntryView from "./ignore_entry_view";
import IndexerHeader from "./indexer/indexer_header";
import LoadAssigner from "./indexer/load_assigner";
import LoadDocumentAssigner from "./indexer/load_document_assigner";
import DocumentBrowserPagination from "../helpers/document_browser_pagination";
import PresenceList from "./presence";
import presenceService from "./presence_service_next_gen";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import "../util/feature_flags";
import WaitingSpinner from "../components/waiting_spinner";
import { EmailForwarderMixin } from "./email_forwarder";
import {
  GroupedDocumentBrowserModel,
  UngroupedGroupCreator
} from "./grouped_document_browser_model";
import { History } from "react-router";
import { IndexerProgress } from "./progress_bars";
import allowedAsPod from "../helpers/allowed_as_pod";
import * as popout from "./popout";
import hotkeys from "../util/hotkeys";
import _ from "underscore";
import React from "react";
import {
  isInNewFlowMode,
  isInExceptionFlowMode,
  addToIgnoredItems
} from "./flow_mode/flow_mode_service";
import { factorInIndexerMode } from "./index_audit_split_mode";
import { setPOD } from "../helpers/documents";
import { types } from "../formatters/documents";
import loadDocumentRelationshipService from "../services/load_document_relationship_service";
import { isPodForLoad } from "./helpers/document_load_relationship_helpers";
function podToggleExtras(load) {
  return { load_state_id: load.id, page: "assign_to_load", pod_toggled: true };
}
const URL_STEPS = ["assignCarrier", "assignTypes", "assignGroups"];
function isUrlStep(value) {
  return typeof value === "string" && URL_STEPS.includes(value);
}
const DocumentIndexer = React.createClass({
  mixins: [EmailForwarderMixin, History],
  // Lifecycle
  getInitialState: function() {
    const settings = Api.Account.currentSettings();
    const setting = settings ? settings["client_notes_sidebar_display"] : void 0;
    const initialSidebarOpen = setting === "expanded";
    return {
      carrier: {
        id: "",
        name: `Unknown ${Account.carrierTerm()}`
      },
      loads: {},
      inFlightGroupLoadRequests: [],
      carrierChoosers: this.initializeCarrierChoosers({}),
      browserExpanded: false,
      continueWithoutInvoiceInformation: false,
      reviewingAuditFlags: false,
      selectedInvoices: [],
      // {group: group, invoice: invoice}
      skipDuplicateCheck: false,
      stepForcedFromUrl: false,
      shipmentDocumentSelections: void 0,
      deliveryDocumentSelections: [],
      sidebarOpen: initialSidebarOpen,
      carrierData: null
    };
  },
  componentDidMount() {
    var _a, _b;
    this.setState({ leftDocumentModel: this.leftDocumentBrowserModel() });
    const requestedStep = (_b = (_a = this.props.location) == null ? void 0 : _a.query) == null ? void 0 : _b.step;
    if (isUrlStep(requestedStep)) {
      this.setState({ stepForcedFromUrl: true });
      this.forceStep(requestedStep);
    }
    if (this.step() === "assignDebtor" && this.groupsWithoutDebtorSelection().length > 0) {
      this.goToGroup(this.groupsWithoutDebtorSelection()[0]);
    }
    hotkeys.listenInComponent(this, AccountsPayable, {
      nextPage: _.partial(this.changePage, "next"),
      prevPage: _.partial(this.changePage, "previous"),
      nextGroup: this.nextGroup,
      prevGroup: this.prevGroup,
      togglePOD: this.togglePOD
    });
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.carrier !== newProps.carrier) {
      this.resolveCarrier(newProps.carrier);
    }
    if (this.props.documentIndexerService.step !== newProps.documentIndexerService.step) {
      if (newProps.documentIndexerService.step === "assignDebtor" && this.groupsWithoutDebtorSelection(newProps.model.groups).length > 0) {
        this.goToGroup(
          this.groupsWithoutDebtorSelection(newProps.model.groups)[0],
          newProps.model
        );
      }
    }
    if (this.props.model !== newProps.model) {
      this.setState({
        carrierChoosers: this.initializeCarrierChoosers(
          this.state.carrierChoosers
        )
      });
      $(newProps.model).on(
        "document-browser-model:page-selected",
        this.pageSelected
      );
      this.fetchLoadsIfNeeded(
        newProps.documentIndexerService,
        newProps.model.selectedGroup
      );
      $(this.props.model).off(
        "document-browser-model:page-selected",
        this.pageSelected
      );
    }
    if (this.props.leftDocumentModel !== newProps.leftDocumentModel) {
      this.setState({ leftDocumentModel: this.leftDocumentBrowserModel() });
    }
    if (this.props.documentBatch !== newProps.documentBatch) {
      presenceService.didFinishViewingCarrier();
    }
    presenceService.didStartViewingCarrier(
      newProps.documentBatch.email_message.carrier_id
    );
  },
  componentWillMount: function() {
    this.resolveCarrier(this.props.carrier).then(() => {
      $(this.props.model).on(
        "document-browser-model:page-selected",
        this.pageSelected
      );
      this.pageSelected();
      presenceService.didStartViewingCarrier(
        this.props.documentBatch.email_message.carrier_id
      );
      DocumentBatchViews.createForDocumentBatch(
        this.props.documentBatch.id
      ).then((view) => this.setState({ documentBatchViewId: view.id }));
    });
  },
  componentWillUnmount: function() {
    if (this.state.documentBatchViewId) {
      DocumentBatchViews.markAsExited(this.state.documentBatchViewId);
    }
    $(this.props.model).off(
      "document-browser-model:page-selected",
      this.pageSelected
    );
    presenceService.didFinishViewingCarrier();
    hotkeys.unlistenInComponent(this);
  },
  // END Lifecycle
  // State setting functions
  preloadActivityItemCarriers: function() {
    const factorInvoiceActivityItems = _.flatten(
      _.pluck(this.props.documentBatch.factor_invoices || [], "activity_items")
    );
    const carrierIds = factorInvoiceActivityItems.map(
      (item) => {
        var _a, _b;
        return (_b = (_a = item.data) == null ? void 0 : _a.factor_invoice) == null ? void 0 : _b.carrier_id;
      }
    );
    [...new Set(carrierIds)].forEach((id) => CarrierService.carrierWithId(id));
  },
  resolveCarrier: function(carrierPromise) {
    return carrierPromise.then((carrier) => {
      this.setState({ carrier });
      if (carrier && carrier.id) {
        CarrierService.carrierWithId(carrier.id).then((fullCarrier) => {
          this.setState({ carrierData: fullCarrier });
        });
      }
      this.preloadActivityItemCarriers();
      return null;
    });
  },
  isSidebarFeatureEnabled: function() {
    const settings = Api.Account.currentSettings();
    if (!settings) return false;
    const setting = settings["client_notes_sidebar_display"];
    return setting && setting !== "disabled";
  },
  handleToggleSidebar: function() {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  },
  renderSidebar: function() {
    var _a;
    if (!this.isSidebarFeatureEnabled() || !this.state.carrierData) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      ClientNotesSidebar,
      {
        key: ((_a = this.state.carrierData) == null ? void 0 : _a.id) || "sidebar",
        warning: this.state.carrierData.warning || null,
        notes: this.state.carrierData.notes || null,
        fundingNotes: this.state.carrierData.funding_notes || null,
        verificationInstructions: this.state.carrierData.verification_instructions || null,
        isOpen: this.state.sidebarOpen,
        onToggle: this.handleToggleSidebar,
        loading: false,
        noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
      }
    );
  },
  renderSidebarTrigger: function() {
    if (!this.isSidebarFeatureEnabled() || !this.state.carrierData) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      ClientNotesSidebarTrigger,
      {
        warning: this.state.carrierData.warning || null,
        notes: this.state.carrierData.notes || null,
        fundingNotes: this.state.carrierData.funding_notes || null,
        verificationInstructions: this.state.carrierData.verification_instructions || null,
        onToggle: this.handleToggleSidebar,
        noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
      }
    );
  },
  editGroups: function() {
    this.forceStep("assignGroups");
  },
  setCarrier: function() {
    this.forceStep("assignCarrier");
  },
  editDocumentType: function() {
    this.forceStep("assignTypes");
  },
  forceDebtorSetterStep: function() {
    this.forceStep("assignDebtor");
  },
  forceReviewStep: function() {
    this.forceStep("review");
  },
  forceStep: function(step) {
    this.setState({ forcedStep: step });
    if (step === "assignDebtor") {
      if (this.groupsWithoutDebtorSelection().length > 0) {
        this.goToGroup(this.groupsWithoutDebtorSelection()[0]);
      } else if (this.props.model.selectedGroup.number === "unassociated") {
        this.goToGroup(this.props.model.groups[0]);
      }
    }
  },
  setSelectedLoad: function(load) {
    const loadId = load ? load.id : void 0;
    const loads = this.state.loads;
    const number = this.props.model.selectedGroup.number;
    loads[number].selected = loadId;
    loads[number].selectedLoad = load;
    this.setLoadAndRelatedState(loads, load, []);
    this.refs.loadAssigner.focusNextField();
  },
  toggleShipmentDocumentSelection: function(shipmentId, document) {
    const shipmentDocumentSelections = this.state.shipmentDocumentSelections;
    const shipmentIndex = shipmentDocumentSelections.findIndex(
      (selection) => selection.shipment.id === shipmentId
    );
    if (shipmentIndex == -1) {
      return null;
    }
    const shipmentDocumentSelection = shipmentDocumentSelections[shipmentIndex];
    const documentIndex = shipmentDocumentSelection.documents.findIndex(
      (doc) => doc.id == document.id
    );
    if (documentIndex === -1) {
      shipmentDocumentSelection.documents.push(document);
    } else {
      shipmentDocumentSelection.documents.splice(documentIndex, 1);
    }
    shipmentDocumentSelections[shipmentIndex] = shipmentDocumentSelection;
    this.setState({ shipmentDocumentSelections });
  },
  toggleDeliveryDocumentSelection: function(entry) {
    if (_.findWhere(this.state.deliveryDocumentSelections, entry)) {
      this.setState({
        deliveryDocumentSelections: _.reject(
          this.state.deliveryDocumentSelections,
          function(deliveryDocument) {
            return _.isEqual(entry, deliveryDocument);
          }
        )
      });
    } else {
      this.setState({
        deliveryDocumentSelections: [
          ...this.state.deliveryDocumentSelections,
          entry
        ]
      });
    }
  },
  updateCarrierChooser: function(carrierChooser) {
    const carrierChoosers = this.state.carrierChoosers;
    const number = this.props.model.selectedGroup.number;
    carrierChoosers[number] = carrierChooser;
    this.setState({ carrierChoosers });
  },
  setSelectedInvoiceForGroup: function(invoice) {
    const selected = this.state.selectedInvoices.filter((s) => {
      return s.group.id !== this.props.model.selectedGroup.id;
    });
    selected.push({ group: this.props.model.selectedGroup, invoice });
    this.setState({ selectedInvoices: selected });
  },
  highlightReference: function(text) {
    this.setState({ textToHighlight: text });
  },
  carrierSetterComplete: function(e) {
    this.setState({ saving: true });
    let contact;
    if (e.contactInfo) {
      contact = this.props.documentBatch.new_contact;
      if (e.contactInfo === "multiple") {
        contact.multi_carrier = true;
      }
      if (e.enableFactorClientPortal) {
        contact.enable_factor_client_portal = true;
      }
    }
    Api.DocumentBatches.setCarrier(
      this.props.documentBatch.id,
      e.isSingleCarrier,
      e.carrierId,
      contact
    ).then(() => {
      this.setSelectedPage();
      this.clearForcedStep();
      if (e && e.carrierId) {
        presenceService.didFinishViewingCarrier();
        presenceService.didStartViewingCarrier(e.carrierId);
      }
      this.setState({ saving: false });
    }).catch(() => {
      this.setState({ saving: false });
    });
  },
  setSelectedPage: function() {
    const unidentified = this.firstUnidentifiedDocument();
    if (unidentified) {
      this.props.model.selectPage(unidentified);
    }
  },
  firstUnidentifiedDocument() {
    const documents = _.flatten(
      _.map(this.props.model.groups, _.property("documents"))
    );
    const unidentified = _.find(documents, (document) => {
      return document.type === null;
    });
    return unidentified && unidentified.pages[0];
  },
  carrierSetterCanceled: function() {
    this.clearForcedStep();
  },
  documentGroupingComplete: function(groups, originalIds) {
    this.setState({ saving: true });
    Api.DocumentBatches.updateGroups(
      this.props.documentBatch.id,
      groups,
      originalIds
    ).then(
      (data) => {
        if (data && data.redirect_to_dashboard) {
          ToDashboardWithFilters(this.props.location, this.history);
          return data;
        }
        this.clearForcedStep();
        if (this.step() !== "assignDebtor") {
          this.props.forceComputeStartPage();
        }
        this.refreshPopout();
        this.setState({ saving: false });
        return data;
      },
      (data) => {
        this.setState({ saving: false });
        return data;
      }
    ).catch(() => {
      this.setState({ saving: false });
    });
  },
  documentGroupingCanceled: function() {
    this.clearForcedStep();
  },
  clearForcedStep: function() {
    var _a, _b;
    if (this.state.forcedStep) {
      this.setState({ forcedStep: void 0 });
    }
    if (this.state.stepForcedFromUrl) {
      this.setState({ stepForcedFromUrl: false });
      (_b = (_a = this.props).returnToWorkflowPageAfterForcedStep) == null ? void 0 : _b.call(_a);
    }
  },
  pageSelected: function() {
    const group = this.props.model.selectedGroup;
    this.fetchLoadsIfNeeded(this.props.documentIndexerService, group);
    this.setState({ group });
  },
  fetchLoadsIfNeeded: function(indexerService, group) {
    if (indexerService.step === "assignLoads" && !this.state.loads[group.number]) {
      const includeRelated = Account.indexShipmentAssignmentEnabled() || Account.indexDeliveryAssignmentEnabled();
      if (_.contains(this.state.inFlightGroupLoadRequests, group.number)) {
        return false;
      } else {
        this.setState({
          inFlightGroupLoadRequests: this.state.inFlightGroupLoadRequests.concat(group.number)
        });
      }
      indexerService.currentGuessedLoads(group, includeRelated).then((data) => {
        var _a;
        const updatedInFlightGroupLoadRequests = this.state.inFlightGroupLoadRequests.filter(
          (groupNumber) => groupNumber !== group.number
        );
        this.setState({
          inFlightGroupLoadRequests: updatedInFlightGroupLoadRequests
        });
        if (!data || !data.loads) {
          return;
        }
        const loads = this.state.loads;
        const respLoads = data.loads;
        const loadId = this.currentlySelectedLoadStateId(group) || (respLoads.length === 1 ? respLoads[0].id : void 0);
        const load = _.findWhere(respLoads, { id: loadId }) || _.first(respLoads);
        loads[group.number] = {
          guessed: respLoads,
          selected: loadId,
          selectedLoad: load
        };
        const relatedShipments = ((_a = data.related) == null ? void 0 : _a.tms_shipments) || [];
        if (this.isMounted()) {
          this.setLoadAndRelatedState(loads, load, relatedShipments);
        }
      });
    }
  },
  setLoadAndRelatedState: function(loads, currentLoad, relatedShipments) {
    var _a, _b, _c, _d;
    let shipmentDocumentSelections = void 0;
    if (Account.indexShipmentAssignmentEnabled()) {
      shipmentDocumentSelections = (_b = (_a = currentLoad == null ? void 0 : currentLoad.load) == null ? void 0 : _a.tms_load_shipments) == null ? void 0 : _b.map(
        (shipment) => {
          var _a2;
          const detailedShipment = relatedShipments == null ? void 0 : relatedShipments.find(
            (relatedShipment) => relatedShipment.id === shipment.tms_shipment_id
          );
          const documentIds = ((_a2 = detailedShipment == null ? void 0 : detailedShipment.shipment_documents) == null ? void 0 : _a2.map((obj) => obj.id)) || [];
          const documents = this.props.model.allDocuments().filter((doc) => documentIds.includes(doc.id));
          return { documents, shipment };
        }
      );
    }
    this.setState({
      loads,
      shipmentDocumentSelections,
      deliveryDocumentSelections: (currentLoad == null ? void 0 : currentLoad.nidf_delivery_documents) || []
    });
    const loadStateIdsToFetch = [];
    const loadId = currentLoad ? currentLoad.id : void 0;
    if (loadId) {
      loadStateIdsToFetch.push(loadId);
    }
    const groupNumber = (_d = (_c = this.props.model) == null ? void 0 : _c.selectedGroup) == null ? void 0 : _d.number;
    if (loads && groupNumber) {
      const guessedLoadStates = loads[groupNumber].guessed;
      if (guessedLoadStates) {
        _.each(guessedLoadStates, (guessedLoadState) => {
          const guessedLoadStateId = guessedLoadState.id;
          const isPresent = loadStateIdsToFetch.some(
            (loadStateId) => loadStateId === guessedLoadStateId
          );
          if (!isPresent) {
            loadStateIdsToFetch.push(guessedLoadStateId);
          }
        });
      }
    }
    if (this.props.updateDocumentLoadRelationships) {
      this.props.updateDocumentLoadRelationships(loadStateIdsToFetch);
    }
  },
  toggleCarrierDocument: function(document, carrierId) {
    if (document.carrier_document_tms_carrier_id) {
      document.carrier_document_tms_carrier_id = null;
      this.forceUpdateAndRefreshPopout();
      Api.Documents.save(document).then((data) => {
        this.forceUpdateAndRefreshPopout();
      });
    } else {
      document.carrier_document_tms_carrier_id = carrierId;
      Api.Documents.setAsCarrierDocument(document, carrierId);
      this.forceUpdateAndRefreshPopout();
    }
  },
  toggleDocumentData: function(document, field) {
    var _a;
    const load = (_a = this.loadsForGroup()) == null ? void 0 : _a.selectedLoad;
    if (field === "includesPOD") {
      const currentIsPod = isPodForLoad(
        document,
        load,
        this.props.documentLoadRelationships
      );
      const newIsPod = !currentIsPod;
      if (!newIsPod) {
        this.removeDeliveryDocumentSelectionsForDocument(document);
      }
      setPOD(document, newIsPod);
      loadDocumentRelationshipService.forcePodDispositionForDocument(
        document.id,
        newIsPod
      );
      this.refreshDocumentLoadRelationships();
    } else {
      document.data[field] = !document.data[field];
    }
    this.forceUpdateAndRefreshPopout();
    const extras = field === "includesPOD" && load ? podToggleExtras(load) : void 0;
    Api.Documents.save(document, extras).then((data) => {
      this.forceUpdateAndRefreshPopout();
    });
  },
  refreshDocumentLoadRelationships: function() {
    if (this.props.updateDocumentLoadRelationships && this.props.documentLoadRelationships) {
      const loadStateIds = [
        ...new Set(
          this.props.documentLoadRelationships.map((r) => r.load_state_id)
        )
      ];
      this.props.updateDocumentLoadRelationships(loadStateIds);
    }
  },
  toggleMarkIllegibleData: function(document, page) {
    page.illegible = !page.illegible;
    this.forceUpdateAndRefreshPopout();
    Api.DocumentPages.markIllegible(page);
  },
  toggleHiddenData: function(document, page) {
    const isHidden = !document.hidden;
    document.hidden = isHidden;
    this.forceUpdateAndRefreshPopout();
    Api.DocumentPages.markHidden(page, isHidden).then((data) => {
      this.forceUpdateAndRefreshPopout();
    });
  },
  toggleClientDebtorOnBol: function(invoice) {
    this.setState({ saving: true });
    invoice.client_or_debtor_on_bol = !invoice.client_or_debtor_on_bol;
    this.forceUpdateAndRefreshPopout();
    Api.FactorInvoices.toggleClientOrDebtorOnBol(
      invoice.id,
      invoice.client_or_debtor_on_bol,
      invoice.data.auditFlags
    ).then((data) => {
      this.setState({ saving: false });
    });
  },
  resolveDocumentException: function(exception, documentGroup) {
    return this.props.documentIndexerService.resolveDocumentException(
      exception,
      documentGroup
    );
  },
  updateDocumentException: function(message, exception, documentGroup) {
    return this.props.documentIndexerService.updateDocumentException(
      message,
      exception,
      documentGroup
    );
  },
  typeComplete: function() {
    this.props.documentIndexerService.updateStep();
    this.forceUpdateAndRefreshPopout();
    this.clearForcedStep();
    this.pageSelected();
  },
  typeUpdated: function(document) {
    this.forceUpdateAndRefreshPopout();
    this.removeDeliveryDocumentSelectionsForDocument(document);
    Api.Documents.save(document).then((data) => {
      this.forceUpdateAndRefreshPopout();
    });
    if (this.isSettingLastType()) {
      this.props.documentIndexerService.updateDocumentGroups(
        this.props.documentBatch.id
      );
    }
  },
  removeDeliveryDocumentSelectionsForDocument: function(document) {
    this.setState({
      deliveryDocumentSelections: this.state.deliveryDocumentSelections.filter(
        (entry) => entry.document_id !== document.id
      )
    });
  },
  isSettingLastType: function() {
    return !this.isForced() && this.allItemsHaveTypes();
  },
  allItemsHaveTypes: function() {
    return _.every(_.pluck(this.props.model.allDocuments(), "type"));
  },
  stepWasClicked: function(step) {
    if (step.number === 0) {
      this.setCarrier();
    } else if (step.number === 1) {
      this.editDocumentType();
    } else if (step.number === 2) {
      this.editGroups();
    } else if (step.number === 3) {
      if (factorInIndexerMode(this.props.location)) {
        this.forceDebtorSetterStep();
      } else {
        this.clearForcedStep();
      }
    } else if (step.number === 4 && factorInIndexerMode(this.props.location)) {
      this.forceReviewStep();
    }
  },
  startIgnoringEntry: function() {
    this.setState({ ignoringEntry: true });
  },
  cancelIgnoringEntry: function() {
    this.setState({ ignoringEntry: false });
  },
  startMergingEmails: function() {
    this.setState({ mergingEmails: true });
  },
  cancelMergingEmails: function() {
    this.setState({ mergingEmails: false });
  },
  skipExceptionItem: function() {
    const { documentBatch } = this.props;
    addToIgnoredItems("document_batch_ids", documentBatch.id);
    ToDashboardWithFilters(this.props.location, this.history);
  },
  // END State setting functions
  forceUpdateAndRefreshPopout: function() {
    this.refreshPopout();
    this.forceUpdate();
  },
  refreshPopout: function() {
    popout.refreshPopout();
  },
  changePage(direction, event) {
    DocumentBrowserPagination.changePage(this.props.model, direction, event);
  },
  togglePOD(event) {
    event.preventDefault();
    event.stopPropagation();
    const document = this.props.model.selectedDocument;
    if (allowedAsPod(document)) {
      this.toggleDocumentData(document, "includesPOD");
    }
  },
  currentGroupIndex() {
    return _.findIndex(
      this.props.model.groups,
      (g) => g.id == this.props.model.selectedGroup.id
    );
  },
  firstPageOfGroup(g) {
    return g.documents && g.documents[0].pages && g.documents[0].pages[0];
  },
  goToGroup(group, newModel = null) {
    const desiredPage = group && this.firstPageOfGroup(group);
    const model = newModel || this.props.model;
    DocumentBrowserPagination.selectPage(desiredPage, model);
  },
  nextGroup(event) {
    event.preventDefault();
    event.stopPropagation();
    const currentGroupIndex = this.currentGroupIndex();
    if (currentGroupIndex < 0) return;
    const desiredGroup = this.props.model.groups[currentGroupIndex + 1];
    if (desiredGroup) {
      if (desiredGroup.name == "Unassociated" && !this.includeUnassociatedGroup()) {
        return;
      }
      this.goToGroup(desiredGroup);
    }
  },
  prevGroup(event) {
    event.preventDefault();
    event.stopPropagation();
    const currentGroupIndex = this.currentGroupIndex();
    if (currentGroupIndex <= 0) return;
    const desiredGroup = this.props.model.groups[currentGroupIndex - 1];
    if (desiredGroup) {
      if (desiredGroup.name == "Unassociated" && !this.includeUnassociatedGroup()) {
        return;
      }
      this.goToGroup(desiredGroup);
    }
  },
  render: function() {
    let load = null;
    const loads = this.loadsForGroup();
    if (!!loads && !!loads.selectedLoad) {
      load = loads.selectedLoad.load;
    }
    const nextFlowModeItem = () => {
      console.log("Flow Mode: Debug move next");
      ToDashboardWithFilters(this.props.location, this.history);
    };
    const flowModeButton = Account.newFlowModeDebuggingEnabled() && isInNewFlowMode(this.props.location.query.onDone) ? /* @__PURE__ */ React.createElement("button", { onClick: nextFlowModeItem, style: { width: "300px" } }, "Next Flow Mode Item") : null;
    return /* @__PURE__ */ React.createElement(
      Blocker,
      {
        "data-component": "DocumentIndexer",
        modalView: this.possibleEmailForwarder(this.props.documentBatch.email_message) || this.possibleIgnoreEntry() || this.possibleMergeEmails()
      },
      /* @__PURE__ */ React.createElement("div", { className: "document-container" }, flowModeButton, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__header" }, /* @__PURE__ */ React.createElement(
        IndexerHeader,
        {
          email: this.props.documentBatch.email_message,
          actions: this.actions(),
          canSetCarrier: this.canSetCarrier(),
          setCarrier: this.setCarrier,
          canIgnoreEntry: this.canIgnoreEntry(),
          ignoreEntry: this.startIgnoringEntry,
          load
        }
      )), /* @__PURE__ */ React.createElement(
        IndexerProgress,
        {
          location: this.props.location,
          onStepClicked: this.stepWasClicked,
          stepNumber: this.currentStepNumber(),
          multiCarrier: this.props.documentBatch.single_carrier === false,
          sidebarTrigger: this.renderSidebarTrigger()
        }
      ), this.documentGrouperOrModule(), /* @__PURE__ */ React.createElement("div", { id: "presence" }, /* @__PURE__ */ React.createElement(
        PresenceList,
        {
          location: this.props.location,
          service: presenceService,
          batchId: this.props.documentBatch.id
        }
      )))
    );
  },
  possibleMergeEmails: function() {
    if (this.state.mergingEmails) {
      return /* @__PURE__ */ React.createElement(
        EmailMergerView,
        {
          onCancel: this.cancelMergingEmails,
          emailId: this.props.documentBatch.email_message.id,
          carrier: this.state.carrier,
          location: this.props.location,
          mergeComplete: this.mergeComplete
        }
      );
    }
  },
  canMerge: function() {
    return this.allDraftInvoices() || this.noInvoices();
  },
  noInvoices: function() {
    return _.isEmpty(this.invoices());
  },
  allDraftInvoices: function() {
    return _.chain(this.invoices()).pluck("state").every((state) => state === "draft").value();
  },
  invoices: function() {
    const batch = this.props.documentBatch;
    return _.compact(batch.factor_invoices.concat(batch.carrier_invoices));
  },
  mergeComplete: function() {
    this.cancelMergingEmails();
    ToDashboardWithFilters(this.props.location, this.history);
  },
  possibleIgnoreEntry: function() {
    if (this.state.ignoringEntry) {
      return /* @__PURE__ */ React.createElement(
        IgnoreEntryView,
        {
          onCancel: this.cancelIgnoringEntry,
          documentBatch: this.props.documentBatch,
          ignoreEntryComplete: this.ignoreEntryComplete
        }
      );
    }
  },
  ignoreEntryComplete: function() {
    this.cancelIgnoringEntry();
    ToDashboardWithFilters(this.props.location, this.history);
  },
  invoicesForGroup: function() {
    const selected = this.loadsForGroup().selectedLoad;
    const selectedCarrierId = this.selectedCarrierID();
    const factoringCompanyIds = _.map(
      this.props.documentBatch.carrier_invoice_submissions,
      "factoring_company_id"
    ).filter((factoringCompanyId) => factoringCompanyId != null);
    return selected ? _.filter(
      this.loadsForGroup().selectedLoad.carrier_invoices,
      (invoice) => {
        return (Account.currentSettings().allow_indexing_customer_only_documents && this.props.documentBatch.customer_only && !invoice.carrier_id || invoice.carrier_id === selectedCarrierId) && (_.isEmpty(factoringCompanyIds) || _.isEmpty(
          invoice.payments_network_submission_factoring_company_ids
        ) || _.isEmpty(
          _.difference(
            invoice.payments_network_submission_factoring_company_ids,
            factoringCompanyIds
          )
        ));
      }
    ) : [];
  },
  getSelectedInvoiceForGroup(defaultInvoice) {
    const invoice = _.find(this.state.selectedInvoices, (selectedInvoice) => {
      return selectedInvoice.group.id === this.props.model.selectedGroup.id;
    });
    return invoice ? invoice.invoice : this.currentlyAssignedInvoiceForGroup() || _.first(this.invoicesForGroup()) || defaultInvoice;
  },
  currentlyAssignedInvoiceForGroup: function() {
    const invoiceID = this.props.model.selectedGroup.documents.map((d) => d.carrier_invoice_id).filter((n) => !!n).shift();
    return this.invoicesForGroup().filter((i) => i.id === invoiceID).shift();
  },
  invoiceCarrierIdForDocumentGroup: function() {
    const carrierInvoiceId = _.first(
      _.uniq(
        _.compact(
          _.pluck(
            this.props.model.selectedGroup.documents,
            "carrier_invoice_id"
          )
        )
      )
    );
    const selectedLoad = this.loadsForGroup().selectedLoad;
    if (carrierInvoiceId && selectedLoad) {
      const carrierInvoice = _.findWhere(selectedLoad.carrier_invoices, {
        id: carrierInvoiceId
      });
      return carrierInvoice ? carrierInvoice.carrier_id : null;
    }
    return null;
  },
  carrierGuesses: function() {
    const load = this.loadsForGroup().selectedLoad;
    let guessedMatchesLoad = false;
    const guessed = _.uniq(
      _.compact(
        _.pluck(this.props.model.selectedGroup.documents, "guessed_carrier_id")
      )
    );
    const invoiceCarrierIdForDocumentGroup = this.invoiceCarrierIdForDocumentGroup();
    const results = _.reject(
      _.map(guessed, (carrierId) => {
        let context = "From Documents";
        if (carrierId && load && load.carrierId === carrierId) {
          if (invoiceCarrierIdForDocumentGroup && invoiceCarrierIdForDocumentGroup === carrierId) {
            context = "From Invoice, TMS Load, and Documents";
          } else {
            context = "From TMS Load and Documents";
          }
          guessedMatchesLoad = true;
        }
        return { carrierID: carrierId, context };
      }),
      function(result) {
        return !result.carrierID;
      }
    );
    if (load && load.carrier_id && !guessedMatchesLoad) {
      let context = "From TMS Load";
      let matchesInvoice = false;
      if (invoiceCarrierIdForDocumentGroup && invoiceCarrierIdForDocumentGroup === load.carrier_id) {
        context = "From Invoice and TMS Load";
        matchesInvoice = true;
      }
      const result = { carrierID: load.carrier_id, context };
      if (matchesInvoice) {
        results.unshift(result);
      } else {
        results.push(result);
      }
    }
    if (invoiceCarrierIdForDocumentGroup && !guessedMatchesLoad && !_.contains(
      _.pluck(results, "carrierID"),
      invoiceCarrierIdForDocumentGroup
    )) {
      results.unshift({
        carrierID: invoiceCarrierIdForDocumentGroup,
        context: "From Invoice"
      });
    }
    return results;
  },
  selectedCarrierID: function() {
    if (this.props.documentBatch.single_carrier) {
      return this.props.documentBatch.carrier_id;
    }
    const carrierChooserState = this.carrierChooser(
      this.props.model.selectedGroup.number
    );
    return CarrierChooser.selectedCarrierID(
      carrierChooserState,
      this.carrierGuesses()
    );
  },
  assignCustomerOnlyDocuments: function() {
    if (Account.currentSettings().allow_indexing_customer_only_documents) {
      const carrierChooserState = this.carrierChooser(
        this.props.model.selectedGroup.number
      );
      return CarrierChooser.assignCustomerOnlyDocuments(carrierChooserState);
    } else {
      return false;
    }
  },
  initializeCarrierChoosers: function(hash) {
    _.map(this.props.model.groups, function(group) {
      hash[group.number] = CarrierChooser.initialState();
    });
    return hash;
  },
  actions: function() {
    const actions = [];
    actions.push(["Forward Email", this.forwardEmail]);
    if (this.canMerge()) {
      actions.push(["Merge Email", this.startMergingEmails]);
    }
    if (Api.Account.indexAuditSplitEnabled() && isInExceptionFlowMode(this.props.location)) {
      actions.push(["Next", this.skipExceptionItem, "next-control"]);
    }
    return actions;
  },
  documentGrouperOrModule: function() {
    const step = this.step();
    if (step === "assignGroups") {
      return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body" }, this.renderSidebar(), /* @__PURE__ */ React.createElement("div", { className: "document-indexer__group-editor-container" }, /* @__PURE__ */ React.createElement(
        DocumentGroupEditor,
        {
          documentBatch: this.props.documentBatch,
          model: this.props.model,
          saving: this.state.saving || false,
          onContinue: this.documentGroupingComplete,
          canCancel: this.canCancelGrouping(),
          toggleDocumentData: this.toggleDocumentData,
          toggleMarkIllegibleData: this.toggleMarkIllegibleData,
          toggleHiddenData: this.toggleHiddenData,
          onCancel: this.documentGroupingCanceled
        }
      )));
    } else if (this.state.reviewingAuditFlags) {
      return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body" }, this.renderSidebar(), /* @__PURE__ */ React.createElement(
        AuditFlagReview,
        {
          onCancel: this.cancelAuditFlagReview,
          onContinue: this.cancelAuditFlagReview,
          auditFlags: this.state.auditReview.auditFlags,
          factorInvoice: this.state.auditReview.factorInvoice,
          documentIds: this.state.auditReview.documentIds,
          model: this.documentBrowserModel(),
          location: this.props.location
        }
      ));
    } else {
      const classes = classNames({
        "x-large-6": !this.state.browserExpanded,
        "small-5": !this.state.browserExpanded,
        "small-10": this.state.browserExpanded,
        column: true,
        "document-indexer__document-side": true
      });
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.props.saving }, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__main-body" }, this.renderSidebar(), this.leftSideModuleOrDocumentBrowser(), /* @__PURE__ */ React.createElement("div", { className: classes }, this.documentBrowserOrEmails())));
    }
  },
  leftSideModuleOrDocumentBrowser: function() {
    if (this.state.browserExpanded) return null;
    const step = this.step();
    if (this.state.leftSelected && (step === "assignLoads" || step === "extractData")) {
      const group = this.state.leftSelected.group;
      const page = this.state.leftDocumentModel ? this.state.leftDocumentModel.selectedPage : this.state.leftSelected.page;
      const documents = this.showLeftDocumentBrowser(page, group);
      return /* @__PURE__ */ React.createElement("div", { className: "xlarge-4 small-5 column document-indexer__left-side-document-browser-area" }, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__left-side-document-browser" }, documents));
    }
    return /* @__PURE__ */ React.createElement("div", { className: "xlarge-4 small-5 column document-indexer__work-area" }, this.leftSideModule());
  },
  documentBrowserOrEmails: function() {
    var _a;
    return /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.props.model || {},
        documentBatch: this.props.documentBatch,
        selectedComponent: this.state.selectedComponent,
        location: this.props.location,
        leftSelected: this.state.leftSelected,
        toggleDocumentData: this.toggleDocumentData,
        toggleMarkIllegibleData: this.toggleMarkIllegibleData,
        toggleHiddenData: this.toggleHiddenData,
        collapseSingleGroup: true,
        textToHighlight: this.state.textToHighlight,
        allowsEditingPodStatus: true,
        currentInvoice: this.invoiceForGroup(),
        toggleClientDebtorCheck: this.toggleClientDebtorOnBol,
        savingInvoice: this.state.saving,
        toggleDeliveryDocument: this.toggleDeliveryDocumentSelection,
        toggleCarrierDocument: this.toggleCarrierDocument,
        canEditDocumentType: true,
        editDocumentType: this.editDocumentType,
        onContextMenu: this.openThumbnailLeft,
        allowsEditing: this.props.allowsEditing,
        expandBrowser: this.expandOrCompressBrowser,
        canDownloadAll: !Auth.getCurrentUser().managed_indexer,
        additionalComponents: this.additionalBrowserComponents(),
        browserExpanded: this.state.browserExpanded,
        includeUnassociatedGroup: this.includeUnassociatedGroup(),
        selectedLoad: (_a = this.loadsForGroup()) == null ? void 0 : _a.selectedLoad,
        shipmentDocumentSelections: this.state.shipmentDocumentSelections,
        toggleShipmentDocument: this.toggleShipmentDocumentSelection,
        documentLoadRelationships: this.props.documentLoadRelationships,
        deliveryDocumentSelections: this.state.deliveryDocumentSelections,
        removeDeliveryDocumentSelectionsForDocument: this.removeDeliveryDocumentSelectionsForDocument,
        forceUpdateAndRefreshPopout: this.forceUpdateAndRefreshPopout
      }
    );
  },
  includeUnassociatedGroup: function() {
    return this.step() !== "assignDebtor";
  },
  documentFromEmail: function() {
    if (this.step() !== "assignTypes") {
      return this.getDocumentFromEmail;
    }
  },
  getDocumentFromEmail: function(emailMessage) {
    const model = this.props.model;
    const groupId = model.selectedGroup.id;
    const emailId = emailMessage.id;
    return documentEditor.documentFromEmail(emailId, groupId);
  },
  documentFromEmailCallback: function() {
    this.props.model.selectPage(
      _.findWhere(this.props.model.activeDocuments(), { type: null }).pages[0]
    );
    this.setState(
      { selectedComponent: "Documents" },
      () => this.setState({ selectedComponent: null })
    );
  },
  additionalBrowserComponents: function() {
    return [
      {
        label: "Messages",
        component: EmailHelper.emailMessages(
          this.emailsForGroup(),
          this.documentFromEmail(),
          this.documentFromEmailCallback
        )
      },
      {
        label: "Activity",
        component: ActivityStreamHelper.invoiceActivity(
          this.activityItemsForGroup()
        )
      }
    ];
  },
  invoiceForGroup: function() {
    return _.detect(
      _.compact(this.invoicesFromBatch()),
      (invoice) => {
        var _a, _b;
        return invoice.id === ((_a = this.groupFromBatch()) == null ? void 0 : _a.carrier_invoice_id) || invoice.id === ((_b = this.groupFromBatch()) == null ? void 0 : _b.factor_invoice_id);
      }
    );
  },
  invoicesFromBatch: function() {
    return this.props.documentBatch.carrier_invoices.concat(
      this.props.documentBatch.factor_invoices
    );
  },
  groupFromBatch: function() {
    return _.detect(
      this.props.documentBatch.document_groups,
      (group) => group.id === this.props.model.selectedGroup.id
    );
  },
  repliesForGroup: function(group) {
    return _.flatten(
      _.map(group.email_messages, (em) => {
        return em.replies;
      })
    );
  },
  emailsForGroup: function() {
    let emails;
    const group = this.groupFromBatch();
    if (group && this.invoiceForGroup()) {
      emails = this.invoiceForGroup().emails.concat(group.email_messages).concat(this.repliesForGroup(group));
    } else if (group) {
      emails = _.compact(
        [this.props.documentBatch.email_message].concat(group.email_messages).concat(this.repliesForGroup(group))
      );
    } else {
      emails = [];
    }
    return _.sortBy(emails, "created_at").reverse();
  },
  // The Elm document viewers use ActivityItemIdsQuery.elm + Search::ActivityItemSearcher#add_document_group to retrieve activity items
  // This function should return the same results as the Elm activity item searches.
  activityItemsForGroup: function() {
    var _a;
    const groupFromBatchActivityItems = ((_a = this.groupFromBatch()) == null ? void 0 : _a.activity_items) || [];
    if (this.invoiceForGroup() && this.groupFromBatch()) {
      const batchItems = _.filter(
        this.props.documentBatch.activity_items,
        (ai) => ai.owner_type != "CarrierInvoice" && ai.owner_type != "FactorInvoice" || ai.owner_id === this.invoiceForGroup().id
      );
      return _.sortBy(
        this.invoiceForGroup().activity_items.concat(
          batchItems,
          groupFromBatchActivityItems
        ),
        "created_at"
      ).reverse();
    } else if (this.groupFromBatch()) {
      return _.sortBy(
        this.props.documentBatch.activity_items.concat(
          groupFromBatchActivityItems
        ),
        "created_at"
      ).reverse();
    } else {
      return [];
    }
  },
  expandOrCompressBrowser: function() {
    this.setState({ browserExpanded: !this.state.browserExpanded });
  },
  openThumbnailLeft: function(group, page) {
    this.state.leftDocumentModel.selectPage(page);
    this.setState({
      leftSelected: { group, page },
      browserExpanded: false
    });
  },
  isForced: function() {
    return !!this.state.forcedStep;
  },
  loadsForGroup: function() {
    return this.state.loads[this.props.model.selectedGroup.number];
  },
  showLeftDocumentBrowser: function(selectedPage, group) {
    const model = this.state.leftDocumentModel;
    model.selectedPage = selectedPage;
    model.groups = [group];
    return /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        closeBrowser: this.closeLeftSideDocumentBrowser,
        model: model || {},
        collapseSingleGroup: true,
        allowsEditingPodStatus: false,
        canEditDocumentType: false,
        allowsEditing: true
      }
    );
  },
  closeLeftSideDocumentBrowser: function() {
    this.setState({ leftSelected: null });
  },
  leftDocumentBrowserModel: function() {
    const currentPage = this.state.leftDocumentModel ? this.state.leftDocumentModel.selectedPage : null;
    return new GroupedDocumentBrowserModel(
      new UngroupedGroupCreator(this.props.documentBatch.documents),
      function() {
        return false;
      },
      currentPage
    );
  },
  documentBrowserModel: function() {
    return new GroupedDocumentBrowserModel(
      new UngroupedGroupCreator(this.props.documentBatch.documents),
      function() {
        return false;
      },
      void 0
    );
  },
  leftSideModule: function() {
    const step = this.step();
    if (step === "assignCarrier") {
      const carrier = this.state.carrier;
      const contact = this.isForced() ? void 0 : this.props.documentBatch.new_contact;
      return /* @__PURE__ */ React.createElement(
        CarrierSetter,
        {
          disallowMultiple: Account.hasRole("Factor"),
          isReceivablesEmail: this.isReceivablesEmail(),
          onSetCarrier: this.carrierSetterComplete,
          carrier,
          saving: this.state.saving || false,
          contact,
          documentBatch: this.props.documentBatch,
          isSingleCarrier: this.props.documentBatch.single_carrier,
          canCancel: this.isForced(),
          onCancel: this.carrierSetterCanceled
        }
      );
    } else if (step === "assignTypes") {
      return /* @__PURE__ */ React.createElement(
        DocumentTypesSetter,
        {
          model: this.props.model,
          isForced: this.isForced(),
          onUpdate: this.typeUpdated,
          onComplete: this.typeComplete,
          documentBatch: this.props.documentBatch,
          documentIndexerService: this.props.documentIndexerService,
          documentTypesTransformer: this.documentTypesTransformer()
        }
      );
    } else if (step === "assignLoads") {
      return this.assignLoadsStepContent();
    } else if (step === "extractData") {
      return /* @__PURE__ */ React.createElement(
        FactorInvoice,
        {
          activeDocuments: this.props.model.activeDocuments(),
          onMergeDocumentBatches: this.props.onMergeDocumentBatches,
          allDocuments: this.props.model.allDocuments(),
          factorInvoiceAbandonedCallback: this.props.factorInvoiceAbandonedCallback,
          location: this.props.location,
          documentBatches: [this.props.documentBatch],
          emailId: this.props.documentBatch.email_message.id,
          groupID: this.props.model.selectedGroup.id,
          hasMore: this.props.hasMore,
          didCompleteGroup: this.props.hasMore ? this.didCompleteGroup : void 0,
          onReviewAuditFlags: this.beginAuditFlagReview,
          continueWithoutInvoiceInformation: this.state.continueWithoutInvoiceInformation,
          onContinueWithoutInvoiceInformation: this.continueWithoutInvoiceInformation,
          model: this.props.model,
          documentBatchContext: this.props.documentBatch,
          carrier: this.props.carrier
        }
      );
    } else if (step === "assignDebtor") {
      return /* @__PURE__ */ React.createElement(
        DebtorSetter,
        {
          groupID: this.props.model.selectedGroup.id,
          groupNumber: this.props.model.selectedGroup.number,
          factorInvoiceId: this.factorInvoiceIdFromActiveDocuments(),
          didCompleteGroup: this.splitFactorDidCompleteGroup,
          carrier: this.props.carrier,
          reloadDocumentBatch: this.props.reloadDocumentBatch
        }
      );
    } else if (step === "review") {
      return /* @__PURE__ */ React.createElement(
        ReviewGroups,
        {
          documentBatchId: this.props.documentBatch.id,
          groups: this.props.model.allGroups,
          location: this.props.location
        }
      );
    }
  },
  documentTypesTransformer() {
    if (this.isBrokerClient() || this.alwaysEnableBrokerClients()) {
      return (types_) => {
        const carrierInvoiceType = types().find(
          (t) => t.value === "carrierInvoice"
        );
        const carrierRateConfirmationType = types().find(
          (t) => t.value === "carrierRateConfirmation"
        );
        return _.chain(
          types_.concat(carrierInvoiceType, carrierRateConfirmationType)
        ).sortBy(_.property("name")).uniq(_.property("name")).value();
      };
    } else {
      return (types2) => types2.filter(
        (type) => type["value"] !== "carrierInvoice" && type["value"] !== "carrierRateConfirmation"
      );
    }
  },
  isBrokerClient() {
    return Account.hasRole("Factor") && this.state.carrier && this.state.carrier.broker_client;
  },
  alwaysEnableBrokerClients() {
    return !!Account.currentSettings().always_allow_broker_client_processing;
  },
  factorInvoiceIdFromActiveDocuments() {
    return _.chain(this.props.model.activeDocuments()).pluck("factor_invoice_id").compact().first().value();
  },
  beginAuditFlagReview(factorInvoice, flags, documentIds) {
    this.setState({
      auditReview: {
        auditFlags: flags,
        factorInvoice,
        documentIds
      },
      reviewingAuditFlags: true
    });
  },
  cancelAuditFlagReview() {
    this.setState({ reviewingAuditFlags: false, auditReview: void 0 });
  },
  continueWithoutInvoiceInformation(shouldContinue) {
    this.setState({ continueWithoutInvoiceInformation: shouldContinue });
  },
  didCompleteGroup: function() {
    this.props.forceComputeStartPage();
  },
  splitFactorDidCompleteGroup: function() {
    if (this.groupsWithoutDebtorSelection().length > 0) {
      this.goToGroup(this.groupsWithoutDebtorSelection()[0]);
    } else {
      this.forceReviewStep();
    }
  },
  groupsWithoutDebtorSelection: function(newPropGroups = null) {
    const groups = newPropGroups || this.props.model.groups;
    return _.reject(groups, function(group) {
      return group.number === "unassociated" || group.factorBrokerId || group.noDebtorSelected;
    });
  },
  assignCurrentGroupToLoadAndInvoiceId: function(loadStateId, carrierInvoiceId, carrierInvoice, carrierID, isFirstLoad, assignCustomerOnlyDocuments, shipmentDocumentSelections) {
    this.setState({ saving: true });
    this.props.assignCurrentGroupToLoadAndInvoiceId(
      loadStateId,
      carrierInvoiceId,
      carrierInvoice,
      carrierID,
      isFirstLoad,
      assignCustomerOnlyDocuments,
      shipmentDocumentSelections,
      this.deliveryDocumentSelectionsForCurrentBatch()
    ).then(() => {
      if (this.isMounted()) this.setState({ saving: false });
    }).catch(() => {
      if (this.isMounted()) this.setState({ saving: false });
    });
  },
  deliveryDocumentSelectionsForCurrentBatch() {
    return this.state.deliveryDocumentSelections.filter((obj) => {
      return _.findWhere(this.props.model.allDocuments(), {
        id: obj.document_id
      });
    });
  },
  assignCurrentGroupToLoad(loadStateId, carrierID) {
    this.setState({ saving: true });
    return this.props.assignCurrentGroupToLoad(
      loadStateId,
      carrierID,
      this.deliveryDocumentSelectionsForCurrentBatch()
    ).then(() => {
      if (this.isMounted()) this.setState({ saving: false });
    }).catch(() => {
      if (this.isMounted()) this.setState({ saving: false });
    });
  },
  selectedDocumentGroup: function() {
    return _.findWhere(this.props.documentBatch.document_groups, {
      id: this.props.model.selectedGroup.id
    }) || this.props.documentBatch.document_groups[0];
  },
  carrierChooser: function(number) {
    if (!this.state.carrierChoosers[number]) {
      this.state.carrierChoosers[number] = CarrierChooser.initialState();
    }
    return this.state.carrierChoosers[number];
  },
  exceptionCreator: function(message, ignore) {
    return this.props.documentIndexerService.saveDocumentException(
      message,
      this.props.model.selectedGroup,
      ignore
    );
  },
  step: function() {
    return this.state.forcedStep || this.props.documentIndexerService.step;
  },
  currentStepNumber: function() {
    if (this.isForced()) {
      const step = this.step();
      return this.props.documentIndexerService.stepNumberForName(step);
    }
    return this.props.documentIndexerService.stepNumber();
  },
  canSetCarrier: function() {
    return this.step() !== "assignCarrier";
  },
  canEditGroups: function() {
    return this.step() === "assignLoads";
  },
  currentlySelectedLoadStateId: function(group) {
    return _.first(
      _.flatten(_.pluck(_.pluck(group.documents, "data"), "load_state_ids"))
    );
  },
  canCancelGrouping: function() {
    return this.props.documentIndexerService.step === "assignLoads";
  },
  canIgnoreEntry: function() {
    return !(this.step() === "assignLoads" && this.showDuplicate());
  },
  showDuplicate: function() {
    return !!(!this.state.skipDuplicateCheck && this.props.documentBatch.duplicateInvoice && this.props.documentBatch.carrierInvoiceSubmission);
  },
  /**
   * Marks duplicate carrier invoice as ignored so we can skip load assignment
   * @param documentBatchId {number}
   * @param carrierInvoiceId {number}
   * @returns {function(): Promise<boolean>}
   */
  ignoreDuplicateInvoice(documentBatchId, carrierInvoiceId) {
    return () => fetch("/api/carrier_invoice_duplicates/ignore", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        document_batch_id: documentBatchId,
        carrier_invoice_id: carrierInvoiceId
      })
    }).then((resp) => resp.status === 200).then((success) => {
      if (success) {
        this.props.skipStep();
      }
      return success;
    }).catch(() => false);
  },
  assignLoadsStepContent() {
    const loads = this.loadsForGroup();
    if (!loads) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: !loads });
    }
    if (this.showDuplicate()) {
      const submission = this.props.documentBatch.carrierInvoiceSubmission;
      const approved = this.props.documentBatch.duplicateInvoice;
      return /* @__PURE__ */ React.createElement(
        DuplicateBrokerInvoiceConfirmation,
        {
          loadStateId: approved.load_state_id,
          carrierName: approved.carrier_name,
          approvedInvoice: {
            senderEmail: approved.emails[0] && approved.emails[0].sender_address,
            invoiceAmount: approved.source_invoice_amount,
            invoiceNumber: approved.source_invoice_number,
            invoiceDate: new Date(approved.source_invoice_date),
            loadId: approved.load_id
          },
          submission: {
            senderEmail: submission.sender_email_address,
            invoiceAmount: submission.amount,
            invoiceNumber: submission.number,
            invoiceDate: new Date(submission.submitted_date)
          },
          onClose: () => Promise.resolve(true).then((resp) => {
            this.setState({ skipDuplicateCheck: true });
            return true;
          }),
          onMarkAsDupe: this.ignoreDuplicateInvoice(
            this.props.documentBatch.id,
            this.props.documentBatch.duplicateInvoice.id
          )
        }
      );
    } else if (this.isTenderAssignment()) {
      return /* @__PURE__ */ React.createElement(
        LoadDocumentAssigner,
        {
          location: this.props.location,
          hasMore: this.props.hasMore,
          documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
          getSelectedInvoiceForGroup: this.getSelectedInvoiceForGroup,
          setSelectedInvoiceForGroup: this.setSelectedInvoiceForGroup,
          currentlyAssignedInvoiceForGroup: this.currentlyAssignedInvoiceForGroup(),
          documentGroup: this.selectedDocumentGroup(),
          saving: this.state.saving || false,
          model: this.props.model,
          email: this.props.documentBatch.email_message,
          documentBatch: this.props.documentBatch,
          assignCurrentGroupToLoad: this.assignCurrentGroupToLoad,
          assignCurrentGroupToLoadAndInvoiceId: this.assignCurrentGroupToLoadAndInvoiceId,
          exceptionCreator: this.exceptionCreator,
          exceptionResolver: this.resolveDocumentException,
          exceptionUpdater: this.updateDocumentException,
          searcher: this.props.documentIndexerService.searchForLoads,
          carrier: this.state.carrier,
          highlightReference: this.highlightReference,
          setSelectedLoad: this.setSelectedLoad,
          carrierChooserState: this.carrierChooser(
            this.props.model.selectedGroup.number
          ),
          onCarrierChooserUpdate: this.updateCarrierChooser,
          multiCarrier: this.props.documentBatch.single_carrier === false,
          group: this.props.model.selectedGroup,
          selectedCarrierID: this.selectedCarrierID(),
          carrierGuesses: this.carrierGuesses,
          assignCustomerOnlyDocuments: this.assignCustomerOnlyDocuments(),
          invoicesForGroup: this.invoicesForGroup(),
          shipmentDocumentSelections: this.state.shipmentDocumentSelections,
          deliveryDocumentSelections: this.state.deliveryDocumentSelections,
          documentLoadRelationships: this.props.documentLoadRelationships,
          ref: "loadAssigner",
          loads
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        LoadAssigner,
        {
          location: this.props.location,
          hasMore: this.props.hasMore,
          documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
          getSelectedInvoiceForGroup: this.getSelectedInvoiceForGroup,
          setSelectedInvoiceForGroup: this.setSelectedInvoiceForGroup,
          currentlyAssignedInvoiceForGroup: this.currentlyAssignedInvoiceForGroup(),
          documentGroup: this.selectedDocumentGroup(),
          saving: this.state.saving || false,
          model: this.props.model,
          email: this.props.documentBatch.email_message,
          documentBatch: this.props.documentBatch,
          assignCurrentGroupToLoadAndInvoiceId: this.assignCurrentGroupToLoadAndInvoiceId,
          exceptionCreator: this.exceptionCreator,
          exceptionResolver: this.resolveDocumentException,
          exceptionUpdater: this.updateDocumentException,
          searcher: this.props.documentIndexerService.searchForLoads,
          carrier: this.state.carrier,
          highlightReference: this.highlightReference,
          setSelectedLoad: this.setSelectedLoad,
          carrierChooserState: this.carrierChooser(
            this.props.model.selectedGroup.number
          ),
          onCarrierChooserUpdate: this.updateCarrierChooser,
          multiCarrier: this.props.documentBatch.single_carrier === false,
          group: this.props.model.selectedGroup,
          selectedCarrierID: this.selectedCarrierID(),
          carrierGuesses: this.carrierGuesses,
          assignCustomerOnlyDocuments: this.assignCustomerOnlyDocuments(),
          invoicesForGroup: this.invoicesForGroup(),
          shipmentDocumentSelections: this.state.shipmentDocumentSelections,
          deliveryDocumentSelections: this.state.deliveryDocumentSelections,
          documentLoadRelationships: this.props.documentLoadRelationships,
          ref: "loadAssigner",
          loads
        }
      );
    }
  },
  isReceivablesEmail() {
    const labels = this.props.documentBatch.email_message.labels;
    function isReceivablesLabel(label) {
      return label.name == "Receivables";
    }
    return labels.some(isReceivablesLabel);
  },
  isTenderAssignment() {
    const nonInvoiceLoadDocumentTypes = Account.nonInvoiceLoadDocumentTypes();
    const isAllNonInvoiceLoadDocumentTypes = _.every(
      this.props.model.selectedGroup.documents,
      (d) => _.contains(nonInvoiceLoadDocumentTypes, d.type)
    );
    return isAllNonInvoiceLoadDocumentTypes;
  }
});
export { DocumentIndexer };
